import { queryStudentPaper } from '@/api'
export default {
  name: 'projectDetails-page',
  data () {
    return {
      rou: 0,
      queryData: {},
      courseInfo: {}, // 课程信息
      summary: null, // 出勤概况
      classDetail: null, // 课程内容
      composite: {}, // 作业
      gradientColor: {
        '0%': '#7CBEFB',
        '100%': '#4982FF'
      },
      currentRate: 0
    }
  },
  created () {
    this.getStudentEvaluationNote()
  },
  destroyed () { },
  methods: {
    Leavingmessage () {
      this.$router.push({ path: '/leavingMessage' })
    },
    async getStudentEvaluationNote () {
      let sellOrderId = null
      let classId = null
      let weekStr = null
      // if (this.$route.query.sellOrderId) {
      //   sellOrderId = this.$route.query.sellOrderId
      //   classId = this.$route.query.classId
      //   weekStr = this.$route.query.weekStr
      // } else {
      //   sellOrderId = this.getQueryString('sellOrderId')
      //   classId = this.getQueryString('classId')
      //   weekStr = this.getQueryString('weekStr')
      // }
      sellOrderId = this.getQueryString('sellOrderId')
      classId = this.getQueryString('classId')
      weekStr = this.getQueryString('weekStr')
      const { data } = await queryStudentPaper({ sellOrderId: sellOrderId, classId: classId, weekStr: weekStr })
      this.queryData = data
      this.courseInfo = data.courseInfo
      this.summary = data.summary
      this.classDetail = data.classDetail
      this.composite = data.composite
      this.rou = this.summary ? 180 * data.summary.up.scale - 180 : 0
    },
    getQueryString (name) {
      const url1 = window.location.search
      const url = decodeURI(url1)
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const r = url.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      };
      return null
    }
  }
}
